import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

const PricingTable = () => {
  const pricingData = [
    { 
      id: 1,
      particulars: 'Salary Income less than 50L + HP Income',
      reasonablePrice: '999',
      offerPrice: '799',
      actualPrice: '1,999',
      discount: '60.00%'
    },
    { 
      id: 2,
      particulars: 'Salary Income More than 50L + HP Income',
      reasonablePrice: '1,999',
      offerPrice: '1,499',
      actualPrice: '3,749',
      discount: '60.00%'
    },
    { 
      id: 3,
      particulars: 'Capital Gain',
      reasonablePrice: '2,999',
      offerPrice: '2,799',
      actualPrice: '6,999',
      discount: '60.00%'
    },
    { 
      id: 4,
      particulars: 'ESOP/RSU/Foreign Income',
      reasonablePrice: '4,499',
      offerPrice: '3,999',
      actualPrice: '9,999',
      discount: '60.00%'
    },
    { 
      id: 5,
      particulars: 'NRI\'s Having Indian Income',
      reasonablePrice: '4,499',
      offerPrice: '3,999',
      actualPrice: '9,999',
      discount: '60.00%'
    },
    { 
      id: 6,
      particulars: 'Crypto Currency Plan',
      reasonablePrice: '4,499',
      offerPrice: '3,999',
      actualPrice: '9,999',
      discount: '60.00%'
    },
    { 
      id: 7,
      particulars: 'Business Owner - Gross Receipt <50L',
      reasonablePrice: '4,499',
      offerPrice: '3,999',
      actualPrice: '9,999',
      discount: '60.00%'
    },
    { 
      id: 8,
      particulars: 'Business Owner - Gross Receipt >50L',
      reasonablePrice: '5,999',
      offerPrice: '4,999',
      actualPrice: '12,499',
      discount: '60.00%'
    },
    { 
      id: 9,
      particulars: 'Future & Options Plan',
      reasonablePrice: '4,499',
      offerPrice: '3,999',
      actualPrice: '9,999',
      discount: '60.00%'
    },
  ];

  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        Service Pricing
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>SI No</TableCell>
              <TableCell>Particulars</TableCell>
              <TableCell align="right">Reasonable Price</TableCell>
              <TableCell align="right">Offer Price</TableCell>
              <TableCell align="right">Actual Price</TableCell>
              <TableCell align="right">Discount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pricingData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.particulars}</TableCell>
                <TableCell align="right">{row.reasonablePrice}</TableCell>
                <TableCell align="right">{row.offerPrice}</TableCell>
                <TableCell align="right">{row.actualPrice}</TableCell>
                <TableCell align="right">{row.discount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PricingTable;